module.exports = __webpack_public_path__ + "img/organization-1.9cb67770.png";